/* eslint-disable indent */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './InfoPage.css';
import { useSelector } from 'react-redux';
import {
  instructionsFormSelector,
  informationOpenSelector,
  shortcutFieldsSelector,
  keyboardShortcutsTextFieldsSelector,
  keyboardShortcutsMultiFieldsSelector,
} from '../../../store/selectors/editForm';
import { bem } from '../../../helpers/styles';
import { PATH_INFO_FORM, PATHS_WITH_TASK_INFO } from '../../../constants/paths';
import useTranslate from '../../../hooks/useTranslate';
import { mountAudioPlayers, unmountAudioPlayers } from '../../../helpers/mountAudioPlayers';
import TaskInfo from './TaskInfo/TaskInfo';

const InfoPage = ({ path }) => {
  const i18n = useTranslate();
  const instructions = useSelector(instructionsFormSelector);
  const isOpen = useSelector(informationOpenSelector);

  const keyboardShortcutsFields = useSelector(shortcutFieldsSelector);
  const keyboardShortcutsTextFields = useSelector(keyboardShortcutsTextFieldsSelector);
  const keyboardShortcutsMultiFields = useSelector(keyboardShortcutsMultiFieldsSelector);

  const ref = useRef();
  const rootsRef = useRef([]); // { root, container }[]

  useEffect(() => {
    if (ref.current) mountAudioPlayers(ref.current, rootsRef);
  }, [ref?.current, instructions]);

  useEffect(() => {
    return () => unmountAudioPlayers(rootsRef);
  }, []);

  return (
    <div className={bem(styles, 'InfoPage', { isOpen: isOpen || path === PATH_INFO_FORM })}>
      {PATHS_WITH_TASK_INFO.includes(path) && <TaskInfo />}
      {instructions && instructions !== '<p><br></p>' && (
        <h2 className={styles.InfoPage__title}>{i18n('InfoPage.title')}</h2>
      )}
      {typeof instructions === 'string' && (
        <div
          ref={ref}
          dangerouslySetInnerHTML={{
            __html: `${instructions}
             ${keyboardShortcutsFields?.length ||
                keyboardShortcutsMultiFields?.length ||
                keyboardShortcutsTextFields?.length
                ? '<h3>Les raccourcis claviers:</h3>'
                : ''
              }
             ${keyboardShortcutsFields?.length
                ? `<ul>
                  ${keyboardShortcutsFields?.reduce(
                  (acc, item) => (item ? acc.concat(`<li>${item}</li>`) : acc),
                  '',
                )}
                </ul>`
                : ''
              }
              ${keyboardShortcutsMultiFields?.length
                ? `<ul>
                  ${keyboardShortcutsMultiFields?.reduce(
                  (acc, item) => (item ? acc.concat(`<li>${item}</li>`) : acc),
                  '',
                )}
                </ul>`
                : ''
              }
              ${keyboardShortcutsTextFields?.length
                ? `<ul>
                  ${keyboardShortcutsTextFields?.reduce(
                  (acc, item) => (item ? acc.concat(`<li>${item}</li>`) : acc),
                  '',
                )}
                </ul>`
                : ''
              }
        `,
          }}
        ></div>
      )}
    </div>
  );
};

InfoPage.propTypes = {
  path: PropTypes.string,
};

export default InfoPage;
